module.exports = __webpack_public_path__ + "img/prod.7ca3bf24.png";